<template>
  <div class="user-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item prop="searchValue" label="关键词">
              <el-input v-model.trim="queryForm.searchValue" placeholder="请输入姓名/电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="appId" label="管理子系统名称" label-width="130px">
              <el-select v-model="queryForm.appId" placeholder="请选择">
                <el-option
                  v-for="item in sysList"
                  :key="item.appId"
                  :label="item.appName"
                  :value="item.appId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="4" :offset="4">
            <el-button type="primary" style="float: right" @click="handleAddUser">新增用户</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table :data="userList" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="name" label="姓名" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="phone" label="电话" align="center" :resizable="false"></el-table-column>
        <el-table-column
          prop="appName"
          label="管理子系统名称"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span
              v-for="(item,index) in row.managerAppNames"
              :key="item.index"
              :style="{ color: item.status == 1 ? '#F56C6C' : '' }"
            >{{ item.name }}{{ item.status == 1 ? '（冻结）' : '' }}{{ index == row.managerAppNames.length - 1 ? '' : ',' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.status === 0 ? true : false"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeSysStatus($event, row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <i
                v-show="!row.status"
                class="iconfont iconcaozuo-1xiugai_1"
                style="margin-right: 16px"
                @click="handleEditUser(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="分配权限" placement="top">
              <i
                v-show="!row.status"
                class="iconfont iconcaozuo-4fenpeiguanliyuanjiaosequanxian_1"
                @click="handleSelectSys(row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新增/编辑用户对话框 -->
    <el-dialog
      :title="userDialogTitle"
      :visible.sync="userDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="cancelSubmit"
    >
      <el-form
        ref="userInfoFormRef"
        :model="userInfoForm"
        :rules="userInfoFormRules"
        label-width="80px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input maxlength="10" v-model="userInfoForm.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="userInfoForm.phone" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="userBtnLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!-- 分配权限 对话框 -->
    <el-dialog
      title="分配子系统超级管理员"
      :visible.sync="sysSelectDialogVisible"
      width="700px"
      @close="onCancel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="left"
        label-width="80px"
        ref="sysSelectFormRef"
        :model="sysSelectForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="userName">
              <span>{{ sysSelectForm.userName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <span>{{ sysSelectForm.phone }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="分配权限"
          prop="appIdList"
          :rules="{ required: true, message: '请选择管理的子系统', trigger: 'change' }"
        >
          <el-select
            v-model="sysSelectForm.appIdList"
            multiple
            placeholder="请选择"
            style="width: 100%"
            @change="sysSelectChange"
          >
            <el-option
              v-for="item in sysList"
              :key="item.appId"
              :label="item.appName"
              :value="item.appId"
              :disabled="item.status === 1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="sysBtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commApi from 'api/common.js';
import userApi from 'api/home/users-mangement.js';

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^(?:(?:\+|00)86)?1\d{10}$/;

      if (value.length === 0) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        // 检验手机号唯一性
        commApi
          .checkPhoneUnique({
            phone: value,
            // 编辑模式下，传入 userId 排除检验自身
            userId: this.isEditMode ? this.userInfoForm.userId : ''
          })
          .then(res => {
            if (res.data.code === 200) {
              callback();
            } else {
              callback(new Error('该手机号已存在，请重新输入'));
            }
          });
      }
    };
    return {
      total: 0,
      queryForm: {
        searchValue: '',
        appId: '',
        pageSize: 10,
        pageNo: 1
      },
      sysList: [],
      tableLoading: true,
      userList: [],
      userInfoForm: {
        userId: '',
        name: '',
        phone: ''
      },
      userInfoFormRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }]
      },
      userDialogTitle: '新增子系统超级管理员',
      userDialogVisible: false,
      userBtnLoading: false,
      isEditMode: false,
      sysSelectDialogVisible: false,
      sysBtnLoading: false,
      sysSelectForm: {
        userId: '',
        userName: '',
        phone: '',
        appIdList: []
      }
    };
  },
  created() {
    this.getSysListData();
    this.getUserListData();
  },
  methods: {
    // 子系统管理员姓名显示格式化
    // 获取子系统下拉列表
    getSysListData() {
      userApi.getSysUserList().then(res => {
        if (res.data.code === 200) {
          this.sysList = res.data.data;
        }
      });
    },
    // 获取用户列表
    getUserListData() {
      this.tableLoading = true;
      userApi
        .getUserList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.userList = res.data.data.rows;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 切换用户状态  newStatus 冻结 1  解冻 0
    changeSysStatus(newStatus, row) {
      userApi
        .postUserStatus({
          userId: row.userId,
          status: newStatus ? 0 : 1
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '修改用户状态成功',
              type: 'success'
            });
            this.getUserListData();
          }
        });
    },
    // 添加用户
    postNewUser() {
      userApi.postNewUser(this.userInfoForm).then(res => {
        if (res.data.code === 200) {
          this.userBtnLoading = false;
          this.$message({
            message: '新增用户成功',
            type: 'success'
          });
          this.cancelSubmit();
          this.handleReset();
        }
      });
    },
    // 编辑用户
    postEditUser() {
      userApi.postEditUser(this.userInfoForm).then(res => {
        if (res.data.code === 200) {
          this.userBtnLoading = false;
          this.$message({
            message: '编辑用户成功',
            type: 'success'
          });
          this.cancelSubmit();
          this.getUserListData();
        }
      });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getUserListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getUserListData();
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNo = 1;
      this.getUserListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getUserListData();
    },
    //  点击新增用户
    handleAddUser() {
      this.isEditMode = false;
      this.userDialogTitle = '新增子系统超级管理员';
      this.userDialogVisible = true;
    },
    resetUserForm() {
      this.userInfoForm.userId = '';
      this.userInfoForm.name = '';
      this.userInfoForm.phone = '';
    },
    // 取消新增/编辑用户
    cancelSubmit() {
      this.userDialogVisible = false;
      this.$refs.userInfoFormRef.resetFields();
      this.resetUserForm();
    },
    // 修改用户信息
    handleEditUser(row) {
      this.isEditMode = true;
      this.userDialogTitle = '编辑子系统超级管理员';
      this.userDialogVisible = true;
      this.userInfoForm.name = row.name;
      this.userInfoForm.phone = row.phone;
      this.userInfoForm.userId = row.userId;
    },
    // 确认新增/编辑用户
    handleSubmit() {
      this.userBtnLoading = true;
      this.$refs.userInfoFormRef.validate(valid => {
        if (!valid) {
          this.userBtnLoading = false;
          return;
        }

        if (this.userInfoForm.userId === '') {
          // 新增接口
          this.postNewUser();
        } else {
          // 编辑接口
          this.postEditUser();
        }
      });
    },
    // 分配权限
    handleSelectSys(row) {
      this.sysSelectForm.userId = row.userId;
      this.sysSelectForm.userName = row.name;
      this.sysSelectForm.phone = row.phone;
      this.sysSelectForm.appIdList = [...row.managerAppIdList];
      this.sysSelectDialogVisible = true;
    },
    // 取消分配权限
    onCancel() {
      this.sysSelectDialogVisible = false;
      this.$refs.sysSelectFormRef.resetFields();
    },
    // 子系统选择事件
    sysSelectChange(value) {
      this.sysSelectForm.appIdList = value;
    },
    // 确认分配权限
    onSubmit() {
      this.sysBtnLoading = true;
      this.$refs.sysSelectFormRef.validate(valid => {
        if (!valid) {
          this.sysBtnLoading = false;
          return;
        }
        userApi.postGrantApp(this.sysSelectForm).then(res => {
          if (res.data.code === 200) {
            this.sysBtnLoading = false;
            this.sysSelectDialogVisible = false;
            this.$message({
              message: '分配权限成功',
              type: 'success'
            });
            this.getUserListData();
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.user-container {
  padding: 16px;

  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
